import { render } from "./SwatchPairInput.vue?vue&type=template&id=5832be0c&ts=true"
import script from "./SwatchPairInput.vue?vue&type=script&lang=ts"
export * from "./SwatchPairInput.vue?vue&type=script&lang=ts"

import "./SwatchPairInput.vue?vue&type=style&index=0&id=5832be0c&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__